import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Splide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import Footer from '../../components/Footer/Footer';
import axios from "axios";
import { Riple } from "react-loading-indicators";
import { useBasket } from '../../context/BasketContext';
import EventCard from "../Home/components/EventCard";
import LogoHeader from "../../components/Header/LogoHeader";
import { API_BASE_URL } from '../../constants/api';

const ScooterEventSelect = () => {

    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const navigate = useNavigate();
    const { clearBasket } = useBasket();

    useEffect(() => {
        axios.get(`${API_BASE_URL}/api/events?key=7678356c642c91a255471d162205e0f3&scooter_booking_status=enabled`)
            .then(response => {
                setEvents(response.data.data);
            })
            .catch(error => {
                console.error('Error fetching events:', error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const handleEventSelect = (event) => {
        const existingBasket = localStorage.getItem('basket');
        const basketHasItems = existingBasket && JSON.parse(existingBasket)?.slots?.length > 0;

        if (basketHasItems) {
            setSelectedEvent(event);
            setShowModal(true);
        } else {
            localStorage.removeItem('bookingConfirmation');
            navigateToEvent(event);
        }
    };

    const navigateToEvent = (event) => {
        navigate('/scooter/event/' + event.id + '/select-type');
    };

    const handleClearAndContinue = () => {
        localStorage.removeItem('basket');
        localStorage.removeItem('customerDetails');
        localStorage.removeItem('bookingConfirmation');
        clearBasket();
        setShowModal(false);
        navigateToEvent(selectedEvent);
    };

    const handleContinueWithoutClearing = () => {
        setShowModal(false);
        navigateToEvent(selectedEvent);
    };

    const visibleEvents = events
        .filter((event) => event.is_live === 1)
        .sort((a, b) => new Date(a.start_at) - new Date(b.start_at));

    return (
        <div className="d-flex flex-column justify-content-between min-vh-100" id="body-container">
            <LogoHeader homeTo="/scooter-event-select" />

            <section className="three-column-cards-carousel bg-motability-mid-black-7 position-relative transform-bg-colour py-32 pt-lg-72 pb-lg-96">
                    <div className="container">
                        <div className="intro-content">
                            <h2 className="text-primary mb-4 mb-lg-32">
                                Select event for scooter or wheelchair booking
                            </h2>
                        </div>


                        {loading ? (
                                    <div className="mt-32 d-flex justify-content-center align-items-center h-100 min-vh-50">
                                        <Riple color="#0052BE" size="medium" text="" textColor="" />
                                    </div>
                                ) : visibleEvents.length === 0 ? (
                                    <p className="mt-4 mt-lg-5 mb-0">No events available</p>
                                ) : (
                        <Splide
                            className="cards-carousel mt-4 mt-lg-5"
                            options={{
                                perPage: 3,
                                gap: '1.5rem',
                                breakpoints: {
                                    991: {
                                        perPage: 2,
                                    },
                                    767: {
                                        perPage: 1,
                                    },
                                },
                                pagination: false,
                                arrows: true,
                            }}
                        >

                            {visibleEvents.map((event) => (
                                    <EventCard
                                        key={event.id}
                                        event={event}
                                        buttonText="Select event"
                                        onSelect={(event) => handleEventSelect(event)}
                                    />
                            ))}
                        </Splide>
                        )}

                    </div>
                </section>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header className="border-0">
                    <Modal.Title className="text-primary fw-semibold">
                        Clear Existing Basket?
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="px-4">
                    <p className="mb-0">
                        You have an existing basket. Would you like to clear it before selecting a new event?
                    </p>
                </Modal.Body>
                <Modal.Footer className="border-0 px-4 pb-4">
                    <div className="d-flex gap-3 w-100">
                        <button
                            className="btn btn-outline-primary flex-grow-1"
                            onClick={handleContinueWithoutClearing}
                        >
                            Continue without clearing
                        </button>
                        <button
                            className="btn btn-primary flex-grow-1"
                            onClick={handleClearAndContinue}
                        >
                            Clear and continue
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            <Footer />

        </div>
    );
};

export default ScooterEventSelect;
